import styled from 'styled-components'
import { COLORS } from 'consts/colors'

/** 32×24 slot: 8px + 16px icon + 8px (matches timeline action button icon sizing). */
export const PlaybackSpeedIconSlot = styled.div`
  flex-shrink: 0;
  box-sizing: border-box;
  width: 32px;
  height: 24px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`
interface IProps {
  $isMobile?: boolean
}
export const PlaybackSpeedTogglerInner = styled.div<IProps>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 24px;
  min-width: 32px;
  padding-right: ${({ $isMobile }) => ($isMobile ? '0px' : '8px')};
  border-radius: 4px;

  path {
    fill: ${COLORS.secondarySemiDark};
  }

  p {
    color: ${COLORS.secondarySemiDark};
  }
`

export const PlaybackSpeedTogglerRoot = styled.div`
  display: flex;
  background-color: transparent;
  height: 24px;

  @media screen and (min-width: 768px) {
    cursor: pointer;

    &:hover {
      ${PlaybackSpeedTogglerInner} {
        background-color: ${COLORS.primaryLight};

        path {
          fill: ${COLORS.secondaryDark};
        }

        p {
          color: ${COLORS.secondaryDark};
        }
      }
    }
  }
  transition: 0.3s;
`
